import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {Router} from '@angular/router';
import {environment} from '../../../../environments/environment';
import {Affirmation} from '../../../models/applicationFeature';
import {CommonService} from '../../../services/common.service';
import {ConsentsFormService} from '../../../services/consents-form.service';
import {LocalStorageService} from '../../../services/local-storage.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {ConsentPrintDialogComponent} from '../../dialogs/consent-print-dialog/consent-print-dialog.component';
import {ConfirmDialogComponent} from '../../shared/confirm-dialog/confirm-dialog.component';


@Component({
    selector: 'app-forms',
    templateUrl: './forms.component.html',
    styleUrls: ['./forms.component.scss']
})
export class FormsComponent implements OnInit {
    //#region Class members
    forms: any[] = [];
    localEnvironment = environment;

    displayForms: any[] = [];
    announcements: any[] = [];
    displayAnnouncements: any[] = [];
    isLoading: boolean;
    selectedCategory: any;
    categoryTypes: any;
    formSearchValue: any;
    listHeight: number;
    pageTitle: string;
    searchAnnouncementValue: string;
    searchConsentsValue: string;
    searchAffirmationValue: string;
    searchRegistrationValue: string;
    affirmations: Affirmation[] = [];
    displayAffirmations: any[] = [];
    registrations: any[] = [];
    displayRegistrations: any[] = [];
    customForms: any[] = [];
    displayCustomForms: any[] = [];
    searchCustomFormValue = '';
    displayOption = 'card';
    displayedColumns = ['title', 'created_by_display_name', 'date_created', 'isPublished', 'has_deadline', 'has_max_slots', 'modified_by_display_name', 'date_modified', 'actions'];
    consentTableDataSource = new MatTableDataSource<any>();
    affirmationTableDataSource = new MatTableDataSource<any>();
    registrationTableDataSource = new MatTableDataSource<any>();
    private paginator: MatPaginator;
    private affirmationPaginator: MatPaginator;
    private registrationPaginator: MatPaginator;
    private sort: MatSort;
    tableHeight: any;
    currentUser: any;

    @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
        this.paginator = mp;
        this.setDataSourceAttributes();
    }

    @ViewChild('paginatorAffirmations') set matPaginator2(mp: MatPaginator) {
        try {
            this.affirmationPaginator = mp;
            this.affirmationTableDataSource.paginator = this.affirmationPaginator;
            this.commonService.setPaginatorTexts(this.affirmationPaginator);
        } catch (e) {

        }
        // this.consentTableDataSource.sort = this.sort;
    }

    @ViewChild('paginatorRegistrations') set matPaginator3(mp: MatPaginator) {
        try {
            this.registrationPaginator = mp;
            this.registrationTableDataSource.paginator = this.registrationPaginator;
            this.commonService.setPaginatorTexts(this.registrationPaginator);
        } catch (e) {

        }
    }

    setDataSourceAttributes() {
        try {
            this.consentTableDataSource.paginator = this.paginator;
            this.consentTableDataSource.sort = this.sort;
            this.commonService.setPaginatorTexts(this.paginator);
        } catch (e) {

        }
    }

    //#endregion

    //#region Constructor and OnInit functions
    constructor(private commonService: CommonService,
                public router: Router,
                public dialog: MatDialog,
                private consentsFormService: ConsentsFormService,
                public toastMessagesService: ToastMessagesService,
                private localStorageService: LocalStorageService) {
        this.isLoading = true;
        this.pageTitle = 'Δηλώσεις';
        this.categoryTypes = [];
        this.formSearchValue = '';
        this.searchConsentsValue = '';
        this.searchAffirmationValue = '';
        this.searchRegistrationValue = '';
        this.searchAnnouncementValue = '';
        this.tableHeight = window.innerHeight - 420;
        this.listHeight = window.innerHeight - 440;
        this.currentUser = JSON.parse(this.localStorageService.get('user'));
        this.displayOption = 'list';

        const option = localStorage.getItem('displayOption');
        if (option) {
            // this.displayOption = option;
            this.displayOption = 'list';
        }
    }

    async ngOnInit() {
        await this.localStorageService.clear('editForm');
        await this.initializeCustomForms();
    }

    //#endregion

    //#region Requests
    // request forms from server
    async initializeCustomForms() {
        try {
            this.isLoading = true;

            const formsRequest = await this.commonService.getList('forms/custom');

            this.customForms = formsRequest.object;


            console.log(`Got: ${this.customForms.length} forms`);
            this.forms = this.customForms.filter(form => form.form_type_id === 1);
            this.displayCustomForms = this.forms.slice();

            this.displayForms = this.forms.slice();
            this.consentTableDataSource = new MatTableDataSource<any>(this.forms);

            this.affirmations = this.customForms.filter(form => form.form_type_id === 10);
            console.log(`public ${this.affirmations.length}`);
            this.displayAffirmations = this.affirmations.slice();
            this.affirmationTableDataSource = new MatTableDataSource<any>(this.displayAffirmations);

            // Δηλώσεις εγγραφής (form_type_id === 2)
            this.registrations = this.customForms.filter(form => form.form_type_id === 2);
            console.log(`registrations ${this.registrations.length}`);
            this.displayRegistrations = this.registrations.slice();
            this.registrationTableDataSource = new MatTableDataSource<any>(this.displayRegistrations);

            console.log(`done formatting`);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να φέρουμε τις προσαρμοσμένες δηλώσεις');
        } finally {
            this.isLoading = false;
        }
    }

    async initializeForms() {
        try {
            const formsRequest = await this.commonService.getList('forms/forms');

            for (const object of formsRequest.object) {
                object.isGDPR = object.isGDPR ? object.isGDPR === 1 ? 'NAI' : 'OXI' : 'ΟΧΙ';
                object.has_two_factor = object.has_two_factor ? object.isGDPR === 1 ? 'NAI' : 'OXI' : 'ΟΧΙ';
            }

            this.forms = formsRequest.object.filter(form => form.form_type_id === 1);
            this.displayForms = formsRequest.object.filter(form => form.form_type_id === 1);
            this.affirmations = formsRequest.object.filter(form => form.form_type_id === 10);
            this.displayAffirmations = formsRequest.object.filter(form => form.form_type_id === 10);
            console.log(this.affirmations.length);
        } catch (e) {
            console.log(e.message);
        }
    }

    async initAffirmations() {
        try {
            const affirmationsRequest = await this.commonService.getList('affirmations');
            this.affirmations = affirmationsRequest.object as Affirmation[];
            this.displayAffirmations = affirmationsRequest.object as Affirmation[];
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    //#region form actions
    // Preview form


    async editForm(form) {
        this.localStorageService.set('editForm', JSON.stringify(form));
        await this.router.navigate(['/home/form-creator'], {queryParams: {mode: true}});
    }

    //#endregion
    searchForms(tabIndex: number, $event?: any) {
        let filterValue = '';
        switch (tabIndex) {
            case 0 :
                filterValue = this.searchConsentsValue ? this.searchConsentsValue.trim().toLowerCase() : '';
                if (this.displayOption === 'card') {
                    this.displayForms = filterValue ?
                        this.forms.filter(form => form.title.trim().toLowerCase().includes(filterValue)) :
                        this.forms;
                } else {
                    this.consentTableDataSource.filter = filterValue;
                }
                break;
            case 1:
                filterValue = this.searchAffirmationValue ? this.searchAffirmationValue.trim().toLowerCase() : '';
                if (this.displayOption === 'card') {
                    this.displayAffirmations = filterValue ?
                        this.affirmations.filter(affirmation => affirmation.title.trim().toLowerCase().includes(filterValue)) :
                        this.affirmations;
                } else {
                    this.affirmationTableDataSource.filter = filterValue;
                }
                break;
            case 2:
                filterValue = this.searchCustomFormValue ? this.searchCustomFormValue.trim().toLowerCase() : '';
                this.displayCustomForms = filterValue ?
                    this.customForms.filter(form => form.title.trim().toLowerCase().includes(filterValue)) :
                    this.customForms;
                break;
            case 3:
                filterValue = this.searchRegistrationValue ? this.searchRegistrationValue.trim().toLowerCase() : '';
                this.registrationTableDataSource.filter = filterValue;
                break;
        }
    }

    print(form: any) {
        this.dialog.open(ConsentPrintDialogComponent, {
            height: '1000px',
            data: {
                parentId: null,
                childId: null,
                mode: 'display',
                unique_id: form.unique_id
            }
        });
    }

    fastSearch($event: KeyboardEvent) {

    }

    search() {

    }

    duplicateFormEmittedFromChild() {
        window.location.reload();
    }

    async duplicate(form: any) {
        try {
            await this.consentsFormService.duplicateForm(form.unique_id);
            this.duplicateFormEmittedFromChild();
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    deleteFormEmittedFromChild(id: any) {
        const formIndex = this.forms.findIndex(f => f.id === +id);
        const affirmationIndex = this.displayAffirmations.findIndex(f => f.id === +id);
        const customFormIndex = this.displayCustomForms.findIndex(f => f.id === +id);
        if (formIndex !== -1) {
            this.displayForms.splice(formIndex, 1);
            this.toastMessagesService.toastMessages('Η δήλωση διαγράφηκε με επιτυχία');
        }

        if (affirmationIndex !== -1) {
            this.displayAffirmations.splice(affirmationIndex, 1);
            this.toastMessagesService.toastMessages('Η δήλωση διαγράφηκε με επιτυχία');
        }

        if (customFormIndex !== -1) {
            this.displayCustomForms.splice(customFormIndex, 1);
            this.toastMessagesService.toastMessages('Η δήλωση διαγράφηκε με επιτυχία');
        }
    }

    async cancelAffirmation($event: any) {
        await this.initAffirmations();
    }

    async deleteAffirmation($event: boolean) {
        await this.initAffirmations();
    }

    setDisplayOption(option: string) {
        this.displayOption = option;
        console.log(this.displayOption);

        localStorage.setItem('displayOption', option);
    }

    async showConsentForm(form) {
        const inputConfig = {
            parentId: null,
            childId: null,
            mode: 'display',
            unique_id: form.unique_id
        };
        await this.router.navigate(['/home/requestFrom'], {queryParams: inputConfig});
    }

    async editCustomForm(form) {
        await this.router.navigate(['/home/custom-form-creator'], {queryParams: {mode: true, uniqueId: form.unique_id}});
    }

    deleteForm(form) {
        const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
            data: {
                type: 'delete',
                icon: 'delete',
                title: 'Διαγραφή δήλωσης',
                message: `Είστε σίγουροι ότι θέλετε να διαγράψετε την δήλωση?`
            }
        });

        confirmDialog.afterClosed().subscribe(async (response) => {
            if (response) {
                try {
                    let deleteRequest: any;
                    deleteRequest = await this.commonService.deleteItem(`forms/custom?formId=${form.id}`);

                    if (deleteRequest.status === 200) {
                      window.location.reload();
                        // this.deleteFormEmittedFromChild(form.id);
                        // if (form.form_type_id === 1) {
                        //     const index = this.displayForms.indexOf(f => f.id === form.id);
                        //     if (index) {
                        //         this.displayForms.splice(index, 1);
                        //         this.consentTableDataSource = new MatTableDataSource(this.displayForms);
                        //     }
                        // } else {
                        //     const index = this.displayAffirmations.indexOf(f => f.id === form.id);
                        //     if (index) {
                        //         this.displayAffirmations.splice(index, 1);
                        //         this.affirmationTableDataSource = new MatTableDataSource(this.displayAffirmations);
                        //     }
                        // }
                    }
                } catch (e) {
                    this.toastMessagesService.toastErrorMessage(e.message);
                }
            }
        });

    }

    publish(form: any) {

    }

    isEditDisabled(element): boolean {
        if (this.currentUser.roleId === 1) {
            return false;
        } else {
            return !!element.isPublished;
        }

    }

    publishForm(element) {
        const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
            data: {
                type: 'upload',
                icon: 'upload',
                title: 'Δημοσίευση δήλωσης',
                message: `Είστε σίγουροι ότι θέλετε να δημοσιεύσετε τη δήλωση?`
            }
        });

        confirmDialog.afterClosed().subscribe(async (response) => {
            if (response) {
                const model = {
                    formId: element.id,
                    formUniqueId: element.unique_id,
                };

                try {
                    await this.commonService.postRequest(`forms/publish`, model);
                    this.toastMessagesService.toastMessages(`Η φόρμα δημοσιεύθηκε με επιτυχία`);
                } catch (e) {
                    this.toastMessagesService.toastErrorMessage(`Υπήρξε κάποιο πρόβλημα με τη δημοσίευση της φόρμας`);
                }
            }
        });
    }

    async updateFormStatus(formId: number, state: number) {
        try {
            await this.commonService.updateItem(`forms/publish/update?formId=${formId}&state=${state}`, {});
            const index = this.affirmationTableDataSource.data.findIndex(f => +f.id === +formId);
            if (index !== -1) {
                const data = this.affirmationTableDataSource.data[index];
                data.isActive = +state;
                this.toastMessagesService.toastMessages(`Η φόρμα ενημερώθηκε με επιτυχία`);
            }
        } catch (e) {
            console.log(e);
            this.toastMessagesService.toastErrorMessage(`Υπήρξε κάποιο πρόβλημα με την ενημέρωση της φόρμας`);
        }
    }

    copyLink(form: any) {
        const baseUrl = environment.baseUrl;
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = `${baseUrl}/#/publicForm?edit=true&mode=false&unique_id=${form.unique_id}&id=${form.id}`;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        this.toastMessagesService.toastMessages(`Ο σύνδεσμος αντιγράφηκε στο πρόχειρό σας`);
    }
}
